import React, { createContext, useContext } from 'react';

import { REFRESH_TOKEN_COOKIE_KEY } from '@pflegia/types/common/constants/tokens';
import { cookieStorage } from '@pflegia/ui/storage/cookie-storage';

export const AuthContext = createContext<boolean>(false);

interface ProviderProps {
  children: React.ReactNode;
  initialAuthenticated?: boolean;
}

export const AuthProvider: React.FC<ProviderProps> = ({ children, initialAuthenticated = false }) => (
  <AuthContext.Provider
    value={typeof window === 'undefined' ? initialAuthenticated : Boolean(cookieStorage.getItem(REFRESH_TOKEN_COOKIE_KEY))}>
    {children}
  </AuthContext.Provider>
);

export const useAuth = () => useContext(AuthContext);
